//#region Utils Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { CommonHelper } from './common-helper'
import { ReferenceTypeComponent } from './reference-type-component'
import { Dictionary } from './dictionary'
import { SessionModel, DashboardModel } from '../modules/api/api.models'
import { IReferenceType } from '../models/util/interfaces'
import { Enums } from '../models/common'

// #region Core

import { OpOperator } from '../models/core'

// #endregion

// #region Custom

import { ColumnInfo } from '../models/custom'

// #endregion

import { ConfigHelper } from './config-helper'
import { LogHelper } from './log-helper'
import { TypeHelper } from './type-helper'

import {
    DataProviderAction,
    DataProviderActor,
    DataProviderAlarmDef,
    DataProviderAlarmEvent,
    DataProviderAlarmGroup,
    DataProviderArticle,
    DataProviderConfigurationProfile,
    DataProviderConsumer,
    DataProviderConsumerType,
    DataProviderDashboard,
    DataProviderDataType,
    DataProviderDataTypeGroup,
    DataProviderDepository,
    DataProviderDescription,
    DataProviderDevice,
    DataProviderDeviceConnection,
    DataProviderDistributor,
    DataProviderGroupingLocation,
    DataProviderGroupingLocationType,
    DataProviderHttp,
    DataProviderIssue,
    DataProviderLocalStorage,
    DataProviderLocation,
    DataProviderMeasurements,
    DataProviderMeters,
    DataProviderOperator,
    DataProviderOperatorGroup,
    DataProviderOrder,
    DataProviderPackage,
    DataProviderReport,
    DataProviderRoute,
    DataProviderScript,
    DataProviderSession,
    DataProviderSimCard,
    DataProviderSupplier,
    DataProviderSystem,
    DataProviderTariff,
    DataProviderTask,
    DataProviderTaskType,
    DataProviderView,
    IDataProvider,
} from '../data-provider'
import { DataProviderRequestCacheStrategy, DataProviderListResult } from '../data-provider/data-provider.interfaces'

// TODO: remove api
import { Api } from '../modules/api/api.module'

export class DataProvider implements IDataProvider {

    // #region Consts

    public static DOMAIN = location.pathname.replace(/\\/g, '').replace('/', '').toUpperCase()
    public static get URL() { return ConfigHelper.getValue(Enums.SimaxConfigSection.Api, ConfigHelper.Key.RESTUrl) }
    public static get CACHE_SIZE() { return 4 }

    private static SESSION: SessionModel = null
    private static get SESSION_KEY() { return DataProvider.DOMAIN + 'SESSION' }

    private static get LOG_PREFIX() { return 'DataProider' }

    // #endregion

    // #region Ctor

    constructor() {
        this.LocalStorage.loggedOperatorSettings = this.LocalStorage.getLoggedOperatorSettings()
        this.LocalStorage.loggedOperator = this.LocalStorage.getLoggedOperatorSetting(Enums.SimaxOperatorSetting.LoggedOperator)
    }

    // #endregion

    // #region Custom

    //DO USUNIECIA!!! - czemu tu się zapisują tylko id i caption - co z resztą obiektu?
    public getReferenceTables(referenceIds: number[]) {
        return this.System.getDictionaries(referenceIds).then((referenceTables: Dictionary<Dictionary<IReferenceType>>) => {
            var result = {}
            referenceIds.forEach(referenceType => {
                var referenceTable: Dictionary<IReferenceType> = referenceTables.tryGetValue(referenceType)
                if (referenceTable) {
                    result[referenceType] = referenceTable.values().map((opObj, i) => {
                        if (opObj) {
                            return {
                                id: opObj.getReferenceKey(),
                                caption: opObj.toString()
                            }
                        } else {
                            return {
                                id: i,
                                caption: 'See console log.'
                            }
                        }
                    })
                } else {
                    result[referenceType] = null
                }
            })
            return result
        })
    }

    public static convertArrayResult<T>(result: any[], objType: { new(obj): T }): T[] {
        if (!result || result.length == 0)
            return []
        var retVal: T[] = result.map(v => {
            var newObj = new objType(v)
            return newObj
        })
        return retVal
    }

    // #endregion

    // #region Resources

    public static getResources(locale: string): JQueryPromise<any> {
        const deferred: JQueryDeferred<any> = $.Deferred()

        const resourcesAuthKey: string = ConfigHelper.getValue(Enums.SimaxConfigSection.Resources, 'AUTH_KEY', { defaultValue: null })
        const apiUrl: string = ConfigHelper.getValue(Enums.SimaxConfigSection.Api, 'REST_URL', { defaultValue: null })

        if (TypeHelper.isNullOrEmpty(resourcesAuthKey)) {
            LogHelper.error(DataProvider.LOG_PREFIX, 'Missing resource api key')
            deferred.reject('Missing resource api key')
        } else if (TypeHelper.isNullOrEmpty(apiUrl)) {
            LogHelper.error(DataProvider.LOG_PREFIX, 'Missing api url')
            deferred.reject('Missing api url')
        } else {
            $.ajax({
                contentType: 'application/json',
                type: 'POST',
                processData: false,
                url: apiUrl + 'GetResources',
                data: JSON.stringify({
                    session: null,
                    authKey: resourcesAuthKey,
                    cultureInfo: locale,
                    module: Enums.Module.WebSIMAX
                }),
                dataFilter: (data: string, type: string) => {
                    return data
                },
                success: (data: any) => {
                    if (data != null
                        && data.GetResourcesResult != null
                        && data.GetResourcesResult.SerializedResources != null
                    ) {
                        data = data.GetResourcesResult.SerializedResources

                        deferred.resolve(data)
                    } else {
                        LogHelper.error(DataProvider.LOG_PREFIX, 'Resources request has finished successfully but resources havent been returned')
                        deferred.reject('Failed to download resources')
                    }
                },
                error: (error: any) => {
                    LogHelper.error(DataProvider.LOG_PREFIX, error as any)
                    deferred.reject(error)
                }
            })
        }

        return deferred.promise()
    }

    // #endregion

    // #region Session

    public static getSession(): SessionModel {
        if (!this.SESSION) {
            var sessionFromLocalStorage = localStorage.getItem(this.SESSION_KEY)
            if (sessionFromLocalStorage) {
                var session = JSON.parse(sessionFromLocalStorage)
                this.SESSION = session
                return session
            } else {
                CommonHelper.logout()
                return null
            }
        } else {
            return this.SESSION
        }
    }

    public static setSession(session: SessionModel) {
        this.SESSION = session
        localStorage.setItem(this.SESSION_KEY, JSON.stringify(session))
    }

    // #endregion

    // #region Dashboards

    // TODO: we need use new api here
    public static Dashboard = {
        DASHBOARDS_SETTINGS: "DASHBOARDS_SETTINGS",
        dashboards: $.Deferred<DashboardModel[]>(),
        getDashboard: (id: number) => {
            return DataProvider.Dashboard.dashboards.promise().then(dashboards => {
                if (id == 0) {
                    if (dashboards.length == 0) {
                        return <DashboardModel>{
                            descriptions: {},
                            files: [],
                            margin: [],
                            padding: [],
                            rows: [],
                            name: null
                        }
                    }
                    return dashboards[0]
                }

                var findDashboards = dashboards.filter(d => d.idDashboard == id)
                if (findDashboards.length > 0) return findDashboards[0]
                return null
            })
        },
        getDashboards: () => {
            return DataProvider.Dashboard.dashboards.promise()
        },
        refreshDashboards: (api: Api, force: boolean = false) => {
            if (force && 'resolved' == DataProvider.Dashboard.dashboards.state()) {
                DataProvider.Dashboard.dashboards = $.Deferred<DashboardModel[]>()
            }
            // Ważne: Łukasz P. nie chce zapisywać konfiguracji dashboardu
            var appVersion = CommonHelper.getValueFromLocalStorage('APP_VERSION')
            var fromLocalStorage: { version: number, dashboards: DashboardModel[] } = null //CommonHelper.getValueFromLocalStorage(DataProvider.Dashboard.DASHBOARDS_SETTINGS)
            if (!force && fromLocalStorage && fromLocalStorage.version == appVersion) {
                DataProvider.Dashboard.dashboards.resolve(fromLocalStorage.dashboards)
            } else {
                api.dashboard.getDashboardConfig().then(dashboardList => {
                    var dashboards = dashboardList.dashboards
                    /*CommonHelper.setValueToLocalStorage(DataProvider.Dashboard.DASHBOARDS_SETTINGS, {
                        dashboards,
                        version: appVersion
                    })*/
                    DataProvider.Dashboard.dashboards.resolve(dashboards)
                })
            }
        }
    }

    // #endregion

    // #region Inner Data Provider

    public LocalStorage = new DataProviderLocalStorage(this)
    public Http = new DataProviderHttp(this)

    public setDataProviderContext(loggedOperator: OpOperator, cultureName: string, systemVersion: number) {
        const currentCultureName: string = this.LocalStorage.getFromLocalStorage(Enums.SimaxLocalStorageKey.CultureName)

        var contextChanged: boolean

        if ((loggedOperator && this.LocalStorage.loggedOperator != null && this.LocalStorage.loggedOperator.idOperator != loggedOperator.idOperator)
            || (cultureName && currentCultureName != cultureName)
            || (systemVersion && this.LocalStorage.getLoggedOperatorSetting(Enums.SimaxOperatorSetting.DictionaryVersion) != systemVersion))
            contextChanged = true

        if (contextChanged) {
            if (loggedOperator) {
                this.LocalStorage.loggedOperator = loggedOperator
                this.LocalStorage.saveLoggedOperatorSetting(Enums.SimaxOperatorSetting.LoggedOperator, loggedOperator)
            }

            if (cultureName) {
                this.LocalStorage.cultureName = cultureName
                this.LocalStorage.saveToLocalStorage(Enums.SimaxLocalStorageKey.CultureName, cultureName)
            }

            if (systemVersion) {
                this.LocalStorage.saveLoggedOperatorSetting(Enums.SimaxOperatorSetting.DictionaryVersion, systemVersion)
            }

            if (this.LocalStorage.loggedOperator && this.LocalStorage.cultureName && this.LocalStorage.getLoggedOperatorSetting(Enums.SimaxOperatorSetting.DictionaryVersion)) {
                this.LocalStorage.dictionaries = new Dictionary<Dictionary<IReferenceType>>(null)
                this.LocalStorage.removeFromLocalStorage(Enums.SimaxLocalStorageKey.BusinessDictionary, 0)

                console.log('dictionaries cleared')
            }

            return $.Deferred().resolve().promise()
        }

        return this.LocalStorage.restoreDictionaries()
    }

    // #endregion

    //#region Requests

    public sendRequestWithSession(method: string, params: any, resultField: string) {
        params.session = this.LocalStorage.getOperatorSessionJSON()
        return this.Http.sendRequest(method, params, 'session', resultField)
    }

    public sendCachedRequestWithSession<TParams>(method: string, params: TParams, resultField: string, cacheStrategy: DataProviderRequestCacheStrategy<TParams>) {
        return cacheStrategy.request(this, method, params, resultField)
    }

    public sendFilterRequestWithSession<TObject extends IReferenceType = IReferenceType>(
        columns: ColumnInfo[],
        pageNbr: number,
        pageSize: number,
        customWhereClause: string,
        referenceType: Enums.ReferenceType,
        methodName: string,
        valuesField: string,
        additionalArguments: any = null
    ): JQueryPromise<DataProviderListResult<TObject>> {
        var session = this.LocalStorage.getOperatorSessionJSON()

        let args: any = { session }

        if (additionalArguments != null) {
            _.extend(args, additionalArguments)
        }

        _.extend(args, { Columns: columns, PageNbr: pageNbr, PageSize: pageSize, CustomWhereClause: customWhereClause })

        return this.Http
            .sendRequest(methodName, args, "session", valuesField, true)
            .then(result => {
                var values: any[] = result[valuesField]
                var objects: any[] = []

                if (values && values.length > 0) {
                    objects = values.map(object => ReferenceTypeComponent.createReferenceObject(referenceType, object))
                }

                return {
                    objects,
                    totalCount: <number>result.TotalCount || objects.length, // WS nie zwraca całkowitej liczby elementów w niektórych przypadkach (np. ActorGroup)
                    error: result.session.Error ? { code: result.session.Error.Code, msg: result.session.Error.Msg } : null
                }
            })
    }

    //#endregion


    // #region IDataProvider Implementation 

    public Action = new DataProviderAction(this)
    public Actor = new DataProviderActor(this)
    public AlarmDef = new DataProviderAlarmDef(this)
    public AlarmEvent = new DataProviderAlarmEvent(this)
    public AlarmGroup = new DataProviderAlarmGroup(this)
    public Article = new DataProviderArticle(this)
    public ConfigurationProfile = new DataProviderConfigurationProfile(this)
    public Consumer = new DataProviderConsumer(this)
    public ConsumerType = new DataProviderConsumerType(this)
    public Dashboard = new DataProviderDashboard(this)
    public DataType = new DataProviderDataType(this)
    public DataTypeGroup = new DataProviderDataTypeGroup(this)
    public Depository = new DataProviderDepository(this)
    public Device = new DataProviderDevice(this)
    public DeviceConnection = new DataProviderDeviceConnection(this)
    public Description = new DataProviderDescription(this)
    public Distributor = new DataProviderDistributor(this)
    public GroupingLocation = new DataProviderGroupingLocation(this)
    public GroupingLocationType = new DataProviderGroupingLocationType(this)
    public Issue = new DataProviderIssue(this)
    public Location = new DataProviderLocation(this)
    public Measurements = new DataProviderMeasurements(this)
    public Meter = new DataProviderMeters(this)
    public Operator = new DataProviderOperator(this)
    public OperatorGroup = new DataProviderOperatorGroup(this)
    public Order = new DataProviderOrder(this)
    public Package = new DataProviderPackage(this)
    public Report = new DataProviderReport(this)
    public Route = new DataProviderRoute(this)
    public Script = new DataProviderScript(this)
    public Session = new DataProviderSession(this)
    public SimCard = new DataProviderSimCard(this)
    public Supplier = new DataProviderSupplier(this)
    public System = new DataProviderSystem(this)
    public Tariff = new DataProviderTariff(this)
    public Task = new DataProviderTask(this)
    public TaskType = new DataProviderTaskType(this)
    public View = new DataProviderView(this)

    public getDateTimeNow() {
        let now = new Date()
        return now.getTime()
    }

    // #endregion
}
